import { Box, Flex, keyframes } from '@chakra-ui/react';

const shineAnimation = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

const ContestListSkeleton = () => {
  return (
    <Flex gap="16px" flexDirection="column">
      {Array.from({ length: 2 }).map((_, index) => (
        <Box
          key={index}
          width={'100%'}
          height={'60px'}
          borderRadius="16px"
          transition="opacity 0.2s linear"
          backgroundImage="linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%)"
          backgroundSize="400px 100%"
          animation={`${shineAnimation} 1.5s infinite linear`}
        />
      ))}
    </Flex>
  );
};

export default ContestListSkeleton;
